import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Observable, of } from 'rxjs'
import { AuthService, User, TranslationChunkService } from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { AddressService } from './address.service'
import { CommonService } from '../../services/common.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { BillToAddress } from '../../../features/quote/quote-checkout/model/address-models'
import { environment } from '../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit {
  @Input()
  custDetail
  public userAddressSave = false
  public endUserAddress = false
  public addressType: any
  public customerAddresses: Array<any> = new Array()
  public shippingAddress: Array<any> = new Array()
  public newAdd: boolean
  public radioSelected: string
  public addressSelected: string
  public term = ''
  countryNames: any
  selectedCountry: any
  countryRegionNames = []

  // user Address List
  user$: Observable<User>
  userAddressList: Array<BillToAddress> = new Array()
  userAddressList$: Observable<any>
  isLoggedinUser = false
  @Input() componentAddress: string
  @Input() soldToAddress?: any
  @Input() cartName: any
  @Input() isCommissionEligible: boolean = false
  addressForm: FormGroup
  @Output() sendAdd = new EventEmitter<any>()
  @Output() nameAdd = new EventEmitter<any>()
  @Output() custAdd = new EventEmitter<any>()
  @Output() closeAdd = new EventEmitter<any>()
  @Output() reciveEndUserAddress = new EventEmitter<BillToAddress>()
  @Output() reciveShipToAddress = new EventEmitter<BillToAddress>()
  @Output() recieveSoldToAddress = new EventEmitter<BillToAddress>()
  @Output() closeShipAdd = new EventEmitter<boolean>()
  @Output() closeEndAdd = new EventEmitter<boolean>()
  @Output() closeSoldAdd = new EventEmitter<boolean>()
  userType: string
  cartId: string
  isSubmitted: boolean
  showAddProductLoader: boolean

  placeholder
  buyCartId: string
  sendNewAddressEmail = true
  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private auth: AuthService,

    private address: AddressService,
    private activeCartService: ActiveCartFacade,
    private userAccountFacade: UserAccountFacade
  ) {
    this.showAddProductLoader = false
    this.placeholder = 'Search ' + this.componentAddress + ' address'
    this.newAdd = false
    this.addressForm = this.fb.group({
      // firstName: ['', Validators.required],
      companyName: ['', Validators.required],
      line1: ['', Validators.required],
      country: ['', Validators.required],
      city: ['', Validators.required],
      // lastName: ['', Validators.required],
      line2: [''],
      state: [null],
      postalCode: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9 -]*$/),
        ],
      ],
      saveAddress: '',
      endAddress: '',
    })
  }
  // get firstName() {
  //   return this.addressForm.get('firstName');
  // }
  get companyName() {
    return this.addressForm.get('companyName')
  }
  // get lastName() {
  //   return this.addressForm.get('lastName');
  // }

  get line1() {
    return this.addressForm.get('line1')
  }
  get country() {
    return this.addressForm.get('country')
  }
  get state() {
    return this.addressForm.get('state')
  }
  get city() {
    return this.addressForm.get('city')
  }
  get postalCode() {
    return this.addressForm.get('postalCode')
  }
  get saveAddress() {
    return this.addressForm.get('saveAddress')
  }
  ngOnInit(): void {
    this.getCountryList()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )

    this.activeCartService.getActiveCartId().subscribe((cartId) => {
      this.buyCartId = cartId
    })
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
      this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    })
    this.getUserAddressList()
    this.addressSelected = this.customerAddresses[0]?.id
    this.sendAdd.emit(this.userAddressList[0])
    this.custAdd.emit(this.userAddressList[0])

    // API call
    this.getCountryList()
    // this.countryRegions();

    this.placeholder =
      'Search ' + this.componentAddress.toLowerCase() + ' address'
  }

  generateAddressSignature(addr: any): string {
    if (!addr) return '';
    
    return [
      addr.firstName?.trim(),
      addr.lastName?.trim(),
      addr.companyName?.trim(),
      addr.line1?.trim(),
      addr.line2?.trim(),
      addr.town?.trim(),
      addr.region?.name?.trim(),
      addr.country?.name?.trim(),
      addr.postalCode?.trim()
    ].join('|').toLowerCase();
  }

  markMatchingAddressInList(addressList: any[], targetAddress: any): void {
    if (!addressList?.length || !targetAddress) return;

    const targetSignature = this.generateAddressSignature(targetAddress);

    for (const addr of addressList) {
      const currentSignature = this.generateAddressSignature(addr);

      if (currentSignature === targetSignature) {
        addr.isSoldToMatch = true;
        console.log('currentSignature: ', currentSignature);
        break; 
      } else {
        addr.isSoldToMatch = false; 
      }
    }
  }

  addAddress() {
    this.newAdd = true
  }

  onStatusChange(item) {
    this.radioSelected = item.id
    this.userAddressList[item.id]
    item.componentAddress = this.componentAddress
    if (this.componentAddress === 'Ship To') {
      this.reciveShipToAddress.emit(item)
    }
    if (this.componentAddress === 'End Customer') {
      this.reciveEndUserAddress.emit(item)
    }
    if (this.componentAddress === 'Sold to') {
      this.recieveSoldToAddress.emit(item)
    }
  }

  onAddChange(add) {
    this.addressSelected = add.id
    this.userAddressList[add.id]
    add.componentAddress = this.componentAddress
    this.custAdd.emit(this.userAddressList[add.id])
  }
  getSaveAddress(event) {
    this.userAddressSave = event.target.checked
    event.target.value = event.target.checked
    this.addressType = 'Ship To'
    this.addressForm.controls['saveAddress'].setValue(this.userAddressSave)
  }
  getEndAddress(event) {
    this.endUserAddress = event.target.checked
    event.target.value = event.target.checked
    this.addressType = 'End Customer'
    this.addressForm.controls['endAddress'].setValue(this.endUserAddress)
  }
  onSubmit() {
    this.isSubmitted = true
    let addressObj
    if (this.addressForm.valid) {
      if (
        this.addressForm.controls['state'].value != null &&
        this.addressForm.controls['state'].value != ''
      ) {
        addressObj = {
          // firstName: this.addressForm.controls.firstName.value,
          companyName: this.addressForm.controls['companyName'].value,
          // lastName: this.addressForm.controls.lastName.value,
          line1: this.addressForm.controls['line1'].value,
          country: {
            isocode: this.addressForm.controls['country'].value,
          },
          region: {
            isocode: this.addressForm.controls['state'].value,
          },
          town: this.addressForm.controls['city'].value,
          line2: this.addressForm.controls['line2'].value,
          postalCode: this.addressForm.controls['postalCode'].value,
          saveForFuture: this.userAddressSave
            ? this.userAddressSave
            : this.endUserAddress,
          sendNewAddressEmail: this.sendNewAddressEmail,
          //saveForFuture2: this.endUserAddress,
          addressType: this.addressType,
        }
      } else {
        addressObj = {
          // firstName: this.addressForm.controls.firstName.value,
          companyName: this.addressForm.controls['companyName'].value,
          // lastName: this.addressForm.controls.lastName.value,
          line1: this.addressForm.controls['line1'].value,
          country: {
            isocode: this.addressForm.controls['country'].value,
          },
          town: this.addressForm.controls['city'].value,
          line2: this.addressForm.controls['line2'].value,
          postalCode: this.addressForm.controls['postalCode'].value,
          saveForFuture: this.userAddressSave
            ? this.userAddressSave
            : this.endUserAddress,
          sendNewAddressEmail: this.sendNewAddressEmail,
          // saveForFuture2: this.endUserAddress,
          addressType: this.addressType,
        }
      }

      let url_params
      if (this.cartName !== 'rfqcart') {
        url_params = [
          'users',
          'current',
          'vscart',
          this.buyCartId,
          'createAddress',
        ]
      } else {
        url_params = ['users', 'current', 'rfqcart', 'createAddress']
      }

      const api_url = this.commonService.constructUrl(url_params)
      this.commonService.postData(api_url, addressObj).subscribe((success) => {
        this.newAdd = false
        this.isSubmitted = false
        var Obj: BillToAddress
        Obj = {
          country: {
            isocode: success['country'].isocode,
            name: success['country']?.name,
          },
          id: success['id'],
          // firstName: success['firstName'],
          companyName: success['companyName'],
          // lastName: success['lastName'],
          line1: success['line1'],
          line2: success['line2'],
          region: {
            name: success['region']?.name || null,
            isocode: success['region']?.isocode || null,
          },
          postalCode: success['postalCode'],
          saveForFuture: success['saveForFuture'],
          sendNewAddressEmail: success['sendNewAddressEmail'],
          town: success['town'],
        }
        this.userAddressList.push(Obj)
        this.addressForm.reset()
        this.onStatusChange(Obj)
      })
    }
  }

  closeForm() {
    if (this.componentAddress === 'Ship To') {
      this.closeShipAdd.emit(false)
    }
    if (this.componentAddress === 'End Customer') {
      this.closeEndAdd.emit(false)
    }
    if (this.componentAddress === 'Sold to') {
      this.closeSoldAdd.emit(false)
    }
  }

  // Address List API Integration

  addressSearch() {
    if (this.cartName === 'rfqcart') {
      this.showAddProductLoader = true
      const api_params = [
        'users',
        this.userType,
        this.cartName,
        'address',
        this.term,
      ]
      const api_url = this.commonService.constructUrl(api_params)
      this.commonService.getData(api_url).subscribe(
        (success) => {
          this.userAddressList = success['addresses']
          this.showAddProductLoader = false
        },
        (error) => {}
      )
    } else if (
      this.componentAddress == 'Ship To' ||
      this.componentAddress == 'Sold to'
    ) {
      this.activeCartService.getActiveCartId().subscribe((cartId) => {
        this.showAddProductLoader = true
        const api_params = [
          'users',
          this.userType,
          this.cartName,
          cartId,
          'address',
          this.term,
        ]
        const api_url = this.commonService.constructUrl(api_params)
        this.commonService.getData(api_url).subscribe(
          (success) => {
            this.userAddressList = success['addresses']
            this.showAddProductLoader = false
          },
          (error) => {}
        )
      })
    } else {
      this.showAddProductLoader = true
      const api_params = [
        'users',
        this.userType,
        this.cartName,
        'endUseraddress',
        this.term,
      ]
      const api_url = this.commonService.constructUrl(api_params)
      this.commonService.getData(api_url).subscribe(
        (success) => {
          this.userAddressList = success['addresses']
          this.markMatchingAddressInList(this.userAddressList, this.soldToAddress);
          this.showAddProductLoader = false
        },
        (error) => {}
      )
    }
  }
  getUserAddressList() {
    // if(this.isCommissionEligible === true && this.componentAddress == 'Sold to'){
    //   this.userAddressList$ = this.address.getUSerAddressForCommision(this.userType);
    // }
    if (this.cartName != 'rfqcart') {
      if (
        this.componentAddress == 'Ship To' ||
        this.componentAddress == 'Sold to'
      )
        this.userAddressList$ = this.address.getShipSoldForCommision(
          this.userType
        )
      else
        this.userAddressList$ = this.address.getEndUserAddresses(this.userType)
    } else {
      if (this.componentAddress == 'Ship To')
        this.userAddressList$ = this.userAddressList$ =
          this.address.getUserAddressListDetails(this.userType)
      else
        this.userAddressList$ = this.address.getEndUserAddresses(this.userType)
    }
    this.userAddressList$.subscribe((data) => {
      this.userAddressList = data['addresses']
      this.markMatchingAddressInList(this.userAddressList, this.soldToAddress);      
    })
  }

  getCountryList() {
    const countries = 'countries'
    const urlParam = [countries]
    const apiUrl = this.commonService.constructUrl(urlParam)
    let apiParams

    // if(this.componentAddress === 'Ship To'){
    //   apiParams = { fields: 'DEFAULT', type: 'SHIPPING' };
    // }
    // else{
    //   apiParams = { fields: 'DEFAULT', type: 'BILLING' };
    // }
    this.commonService.getData(apiUrl, apiParams).subscribe(
      (success) => {
        this.countryNames = success[countries]
      },
      (error) => {}
    )
  }

  countryRegions() {
    this.selectedCountry = this.addressForm.controls['country'].value
    const regions = 'regions'
    if (this.selectedCountry == 'CN') {
      this.addressForm.controls['postalCode'].clearValidators()
    } else {
      this.addressForm.controls['postalCode'].setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
        Validators.pattern(/^[a-zA-Z0-9 -]*$/),
      ])
    }
    this.addressForm.controls['postalCode'].updateValueAndValidity()
    this.commonService
      .getData(
        environment.occBaseUrl +
          environment.getCountryURL +
          this.selectedCountry +
          '/regions?fields=DEFAULT'
      )
      .subscribe(
        (success) => {
          this.countryRegionNames = success[regions]
          if (this.countryRegionNames?.length > 0) {
            this.addressForm.controls['state'].setValidators([
              Validators.required,
            ])
          } else {
            this.addressForm.controls['state'].clearValidators()
          }
          this.addressForm.controls['state'].updateValueAndValidity()
        },
        (error) => {}
      )
  }
  cancel() {
    this.newAdd = false
    this.addressForm.reset()
  }
}
